import React from "react";
import {
  useConsumerPlanConfig,
  usePlanDetails,
} from "@features/cx/consumerManagement/hooks";
import { Loader2 } from "lucide-react";
import { PlanDetails } from "./PlanDetails";
import { RateStructures } from "./RateStructures";
import { ChargesFeesBreakdown } from "./ChargesFeesBreakdown";
import { SecurityDeposit } from "./SecurityDeposit";

interface PlanAndDepositTabProps {
  consumer?: any;
  consumerId: string;
  consumerNo: string;
  remoteUtilityId: number;
}

export const PlanAndDepositTab: React.FC<PlanAndDepositTabProps> = ({
  consumer,
  consumerId,
  remoteUtilityId,
}) => {
  const cid =
    consumerId ||
    consumer?.id ||
    consumer?.consumerId ||
    consumer?.consumer_id ||
    "";

  const remotePlanId =
    consumer?.planDetails?.id ||
    consumer?.planDetails?.planId ||
    consumer?.planId ||
    consumer?.remotePlanId ||
    "";

  const { data: consumerPlanConfigResponse, isLoading: isConfigLoading } =
    useConsumerPlanConfig(cid, remoteUtilityId);

  const { data: planDetailsResponse, isLoading: isDetailsLoading } =
    usePlanDetails(remoteUtilityId, remotePlanId);

  const isLoading = isConfigLoading && isDetailsLoading;

  const realData = consumerPlanConfigResponse?.result
    ? consumerPlanConfigResponse
    : planDetailsResponse?.result
      ? planDetailsResponse
      : planDetailsResponse
        ? { result: planDetailsResponse }
        : consumer?.planDetails
          ? { result: consumer.planDetails }
          : null;

  const planConfig = realData;

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="w-6 h-6 animate-spin text-blue-600" />
      </div>
    );
  }

  if (!planConfig) {
    return (
      <div className="p-8 text-center text-gray-500 text-sm italic">
        No plan details available
      </div>
    );
  }

  return (
    <div className="space-y-6 pt-2">
      <PlanDetails
        planConfig={planConfig}
        planData={planDetailsResponse?.result}
      />
      <RateStructures planConfig={planConfig} />
      <ChargesFeesBreakdown planConfig={planConfig} />
      <SecurityDeposit planConfig={planConfig} />
    </div>
  );
};

export default PlanAndDepositTab;
